// extracted by mini-css-extract-plugin
export default {"main":"Main_main__SqrVH","container":"Main_container__Bgy4k"};